module.exports = __webpack_public_path__ + "static/media/NotoSansCJKjp-Regular.7ed4b9a7.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/noto-sans-jp/NotoSansCJKjp-Regular.otf
// module id = 413
// module chunks = 0